// removed by extract-text-webpack-plugin
module.exports = {"reviewContainer":"_39Bh6","reviewContainerHeader":"jomM1","reviewsList":"_3gRDr","showAllReviewsButton":"SS8gh"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ProductReviewsList/index.sass
// module id = 1500
// module chunks = 1